import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { AccessVerificationForm } from 'containers/forms/auth'
import PropTypes from 'prop-types'

export default class AccessVerification extends Component {
  static propTypes = {
    verifyButtonDisabled: PropTypes.bool.isRequired,
    sendButtonDisabled: PropTypes.bool.isRequired,
    resendMessage: PropTypes.any.isRequired
  }

  render() {
    const { verifyButtonDisabled, sendButtonDisabled, resendMessage } = this.props

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[
          <AccessVerificationForm
            verifyButtonDisabled={verifyButtonDisabled}
            sendButtonDisabled={sendButtonDisabled}
            resendMessage={resendMessage}
          />
        ]}
        colWidth='305px'
      />
    )
  }
}
